export default __webpack_public_path__ + "static/media/head-logo.7f9f952b.jpg";